import styled from 'styled-components'

const StyledLessonPreviewItem = styled.div`
  display: grid;
  grid-gap: 4px;
  align-self: start;
  position: relative;

  .lesson-thumbnail {
    padding-top: 56.25%;
    background: ${({ theme }) => theme.colors.gray[50]};
    border-radius: 3px;
    position: relative;

    img {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 3px;
    }

    &::after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      border-radius: 3px;
      border: 1px solid #00000012;
    }
  }

  .lesson-index {
    font-size: 14px;
    letter-spacing: 0.01rem;
    color: ${({ theme }) => theme.colors.gray[700]};
    font-weight: 700;
    display: block;
    margin-top: 5px;
  }

  .lesson-title {
    font-weight: 500;
    font-size: 14px;
    letter-spacing: 0.01rem;
    color: ${({ theme }) => theme.colors.gray[600]};
    line-height: 21px;
  }

  .lesson-learn-more {
    font-weight: 600;
    font-size: 14px;
    margin-top: 10px;
    letter-spacing: 0.05rem;
    color: ${({ theme }) => theme.colors.green[300]};
  }

  @media (min-width: ${({ theme }) => `${theme.breakpoints.m}px`}) {
    .lesson-learn-more {
      display: none;
    }
  }
`

export default StyledLessonPreviewItem
